<template>
  <el-select v-model="taskType" placeholder="选择任务类型">
    <el-option
      v-for="item in taskTypeArr"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    >
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "TaskTypeSelect",
  props: {},
  data() {
    return {
      taskType: "",
      taskTypeArr: [
        {
          value: 1,
          label: "日常工作",
        },
        {
          value: 2,
          label: "临时工作",
        },
        {
          value: 3,
          label: "重点工作",
        },
        {
          value: 4,
          label: "其他工作",
        },
      ],
    };
  },

  watch: {
    taskType(newVal, oldVal) {
      this.$emit("taskType", this.taskType);
    },
  },
};
</script>

<style scoped lang="scss">
</style>